export default __webpack_public_path__ + "static/media/Fake1.24e711ae.jpg";